import {
  Directive,
  HostListener,
  input,
  ElementRef,
  inject,
} from '@angular/core';
const ALLOWED_KEYS = new Set([
  'Backspace',
  'Tab',
  'ArrowLeft',
  'ArrowRight',
  'Delete',
  'Enter',
]);

const DIGIT_REGEX = /^\d$/;
const LEADING_ZERO_REGEX = /^0/;
const POSITIVE_INTEGER_REGEX = /^[1-9]\d*$/;

@Directive({
  selector: '[corePositiveNumbers]',
  standalone: true,
})
export class PositiveNumbersDirective {
  private el = inject<ElementRef<HTMLInputElement>>(ElementRef);

  isEnabled = input<boolean>(true, { alias: 'corePositiveNumbers' });

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (!this.isEnabled()) return;

    if (ALLOWED_KEYS.has(event.key)) return;

    if (!DIGIT_REGEX.test(event.key)) {
      event.preventDefault();
      return;
    }

    const input = this.el.nativeElement;
    const { selectionStart, selectionEnd, value } = input;

    if (selectionStart === null || selectionEnd === null) return;

    const newValue =
      value.slice(0, selectionStart) + event.key + value.slice(selectionEnd);

    if (LEADING_ZERO_REGEX.test(newValue)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    if (!this.isEnabled()) return;

    const pastedText = event.clipboardData?.getData('text') || '';

    if (!POSITIVE_INTEGER_REGEX.test(pastedText)) {
      event.preventDefault();
    }
  }
}
